import type { FC } from "react";
import { useIntl } from "react-intl";
import { Outlet } from "react-router-dom";
import { useAuthorizedValue, useLicensedValue } from "@packsize/authentication";
import { PageContainer, SecondaryNavbar, SiteContainer, type NavbarItem } from "@packsize/components";

import { scheduledReportPermissions } from "@/views/configuration/roles/role-utils";

import { ReportingProvider } from "./contexts";

const ReportingNav: FC = () => {
	const intl = useIntl();

	const tabs: NavbarItem[] = (
		[
			useLicensedValue(
				useAuthorizedValue(
					{
						link: "carton/production",
						text: intl.formatMessage({ id: "Cartons", defaultMessage: "Cartons" }),
					},
					"AccessCartonProductionReport",
				),
				"Reporting",
				"basic",
				undefined,
				true,
				null,
				true,
			),
			useLicensedValue(
				useAuthorizedValue(
					{
						link: "material-usage",
						text: intl.formatMessage({ id: "Material Usage", defaultMessage: "Material Usage" }),
					},
					"AccessZFoldUsageReport",
				),
				"Reporting",
				"basic",
				undefined,
				true,
				null,
				true,
			),
			useLicensedValue(
				useAuthorizedValue(
					{ link: "trim", text: intl.formatMessage({ id: "Trim", defaultMessage: "Trim" }) },
					"AccessTrimReport",
				),
				"Reporting",
				"basic",
				undefined,
				true,
				null,
				true,
			),
			useLicensedValue(
				useAuthorizedValue(
					{
						link: "errors",
						text: intl.formatMessage({ id: "Errors and Availability", defaultMessage: "Errors & Availability" }),
					},
					"AccessMachineErrorsReport",
				),
				"Reporting",
				"professional",
				undefined,
				true,
				null,
				true,
			),
			useLicensedValue(
				useAuthorizedValue(
					{ link: "oee", text: intl.formatMessage({ id: "OEE", defaultMessage: "OEE" }) },
					"AccessOverallEquipmentEffectiveness",
				),
				"Reporting",
				"enterprise",
				undefined,
				true,
				null,
				true,
			),
			useLicensedValue(
				useAuthorizedValue(
					{ link: "raw-data", text: intl.formatMessage({ id: "Raw Data", defaultMessage: "Raw Data" }) },
					"AccessRawDataReport",
				),
				"Reporting",
				"professional",
				undefined,
				true,
				null,
				true,
			),
			useLicensedValue(
				useAuthorizedValue(
					{
						link: "scheduled-reports",
						text: intl.formatMessage({ id: "Scheduled Reports", defaultMessage: "Scheduled Reports" }),
					},
					scheduledReportPermissions,
				),
				"Reporting",
				"basic",
				undefined,
				true,
				null,
				true,
			),
		] as (NavbarItem | null)[]
	).filter((tab): tab is NavbarItem => tab !== null);

	return (
		<SiteContainer header={<SecondaryNavbar navbarItems={tabs} />}>
			<PageContainer>
				<ReportingProvider>
					<Outlet />
				</ReportingProvider>
			</PageContainer>
		</SiteContainer>
	);
};

export default ReportingNav;
